import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { AcceleratorCourseAssignment } from '@interfaces';
import { AppService } from '../../../../../../services';
import { ExperienceAreaService } from '../../../../experience-area.service';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, app: AppService, dialog: DialogService, expAreaService: ExperienceAreaService): GridSetup<AcceleratorCourseAssignment> {

	return {
		rowName: { singular: 'Accelerator Course Assignment', plural: 'Accelerator Course Assignments' },
		getRowKey: row => '' + row.accId,
		stateKey: 'experience-scheduling-accelerator-course-assignments-grid',
		actions: getActions(dialog, expAreaService),
		buttons: [],
		columns: getColumns(util, app),
	}
}
